import { supabase } from '../../../../../../data/supabase'
import React, { useEffect, useState } from 'react'

function AdvancedTestesTable() {
  const [testes, setTestes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [count, setCount] = useState(0)
  const [orderBy, setOrderBy] = useState('created_at')
  const [ascending, setAscending] = useState(false)

  useEffect(() => {
    fetchTestes()
    fetchCount()
  }, [page, rowsPerPage, orderBy, ascending])

  async function fetchCount() {
    try {
      const { count, error } = await supabase
        .from('testes')
        .select('id', { count: 'exact', head: true })
      
      if (error) throw error
      
      setCount(count || 0)
    } catch (error) {
      console.error('Erro ao contar registros:', error.message)
    }
  }

  async function fetchTestes() {
    try {
      setLoading(true)
      
      const { data, error } = await supabase
        .from('testes')
        .select('id, name, email, created_at')
        .order(orderBy, { ascending })
        .range(page * rowsPerPage, (page + 1) * rowsPerPage - 1)
      
      if (error) throw error
      
      setTestes(data)
    } catch (error) {
      console.error('Erro ao buscar dados:', error.message)
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleSort = (column) => {
    if (orderBy === column) {
      setAscending(!ascending)
    } else {
      setOrderBy(column)
      setAscending(true)
    }
    setPage(0)
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString()
  }

  const handleChangePage = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  if (loading && page === 0) {
    return (
      <div className="flex justify-center items-center h-64">
        <span className="loading loading-spinner loading-lg text-primary"></span>
      </div>
    )
  }
  
  if (error) {
    return (
      <div className="alert alert-error shadow-lg">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          <span>Erro ao carregar dados: {error}</span>
        </div>
      </div>
    )
  }

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-6">Lista de Testes</h2>
      
      {/* Seletor de registros por página */}
      <div className="mb-4">
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text">Registros por página</span>
          </label>
          <select 
            className="select select-bordered" 
            value={rowsPerPage} 
            onChange={handleChangeRowsPerPage}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>
      
      {/* Tabela no estilo fornecido */}
      <div className="overflow-x-auto w-full">
        <table className="table w-full overflow-hidden h-full">
          {testes?.length > 0 && (
            <thead>
              <tr>
                <th 
                  className="cursor-pointer"
                  onClick={() => handleSort('id')}
                >
                  ID {orderBy === 'id' && (ascending ? '↑' : '↓')}
                </th>
                <th 
                  className="cursor-pointer"
                  onClick={() => handleSort('name')}
                >
                  Nome {orderBy === 'name' && (ascending ? '↑' : '↓')}
                </th>
                <th 
                  className="cursor-pointer"
                  onClick={() => handleSort('email')}
                >
                  Email {orderBy === 'email' && (ascending ? '↑' : '↓')}
                </th>
                <th 
                  className="cursor-pointer"
                  onClick={() => handleSort('created_at')}
                >
                  Data de Criação {orderBy === 'created_at' && (ascending ? '↑' : '↓')}
                </th>
              </tr>
            </thead>
          )}
          <tbody>
            {testes?.length > 0 ? (
              testes.map((teste, k) => (
                <tr key={k}>
                  <td className="font-bold">{teste.id}</td>
                  <td className="font-bold flex">
                    <span>{teste.name}</span>
                  </td>
                  <td>{teste.email}</td>
                  <td>{formatDate(teste.created_at)}</td>
                  
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">
                  <span className="flex pt-6 text-[#666] font-bold">
                    Nada encontrado.
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      {/* Paginação */}
      {testes?.length > 0 && (
        <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-4">
          <div className="text-sm text-[#666]">
            Mostrando {page * rowsPerPage + 1} - {Math.min((page + 1) * rowsPerPage, count)} de {count} registros
          </div>
          
          <div className="join">
            <button 
              className="join-item btn"
              onClick={() => handleChangePage(0)} 
              disabled={page === 0}
            >
              «
            </button>
            <button 
              className="join-item btn"
              onClick={() => handleChangePage(page - 1)} 
              disabled={page === 0}
            >
              ‹
            </button>
            <button className="join-item btn">
              Página {page + 1} de {Math.ceil(count / rowsPerPage)}
            </button>
            <button 
              className="join-item btn"
              onClick={() => handleChangePage(page + 1)} 
              disabled={(page + 1) * rowsPerPage >= count}
            >
              ›
            </button>
            <button 
              className="join-item btn"
              onClick={() => handleChangePage(Math.ceil(count / rowsPerPage) - 1)} 
              disabled={(page + 1) * rowsPerPage >= count}
            >
              »
            </button>
          </div>
        </div>
      )}
      
      {/* Loading indicator durante carregamento de dados */}
      {loading && page > 0 && (
        <div className="flex justify-center mt-4">
          <span className="loading loading-dots loading-md"></span>
        </div>
      )}
    </div>
  )
}

export default AdvancedTestesTable